// extracted by mini-css-extract-plugin
module.exports = {"carousel":"WorkCarousel-module--carousel--3EjAu","image":"WorkCarousel-module--image--15bh9"};